import { EmailDetails } from "../models/emailDetails";
import { EmailRepo } from "../email.repo";
import { EmailStatus } from "../../portfolioadmin/reportManagement/models/emailStatus";

class EmailsController implements angular.IOnInit {
  public emails: EmailDetails[]

  /** @ngInject */
  constructor(private $window: angular.IWindowService, private $state: angular.ui.IStateService,
    private $mdDialog: angular.material.IDialogService, private emailRepo: EmailRepo) { }

  $onInit(): void {
    // TODO: Get emails
    this.emailRepo.getGroupEmails()
      .then(emails => {
        this.emails = emails.map(e => ({
          ...e,
          statuses: {
            sent: e.recipients.filter(r => r.emailStatus === EmailStatus.SENT).length,
            sending: e.recipients.filter(r => r.emailStatus === EmailStatus.SENDING || r.emailStatus === EmailStatus.PENDING).length,
            failed: e.recipients.filter(r => r.emailStatus === EmailStatus.FAILED).length
          },
          viewDetails: false
        }));
      });
  }

  newEmail() {
    this.$state.go('.create');
  }

  viewEmail(email: EmailDetails) {
    this.$mdDialog.show(
      this.$mdDialog.alert()
        .title(email.subject)
        .htmlContent('<div>' + email.message + '</div>')
        .ok('Close')
    );
  }

  failedAndPending(email: EmailDetails) {
    return email.recipients.filter(r => r.emailStatus === EmailStatus.SENDING || r.emailStatus === EmailStatus.PENDING || r.emailStatus === EmailStatus.FAILED);

  }

  toggleDetails(email: EmailDetails) {
    email.viewDetails = !email.viewDetails;
  }

  downloadEmailAttachment(attachmentDetails) {
    this.emailRepo.downloadAttachment(attachmentDetails.attachmentId)
      .then(res => {
        const attachment = res.data as any;
        this.$window.open(attachment.url, '_blank');
      })
  }
}

export const emails: angular.IComponentOptions = {
  controller: EmailsController,
  template: require('./emails.html')
}



// WEBPACK FOOTER //
// ./src/app/bulkemailing/views/emails.ts